import React from "react";
import Styles from './styles.module.scss'

import Seo from "../../components/_UI/seo";
import {useTranslation} from "react-i18next";

import TeamS1 from "../../components/teamS1";
import TeamS2 from "../../components/teamS2";
import TeamS3 from "../../components/teamS3";




const TeamPage = () => {
    const { t } = useTranslation();

    return (
        <section className={`${Styles.container}`}>
            <Seo title={t('Team')}/>
            <TeamS1/>
            <TeamS2/>
            <TeamS3/>
        </section>
    );
};

export default TeamPage;